import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ProviderRequestsDashboard = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/my-requests`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setRequests(res.data);
    } catch (err) {
      toast.error('Failed to load requests');
      console.error(err);
    }
    setLoading(false);
  };

  const handleStatus = async (id, status) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}oosh/service/service/${id}`, { status }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      toast.success(`Request ${status}`);
      fetchRequests();
    } catch (err) {
      toast.error('Action failed');
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-6 text-blue-600">My Service Requests</h2>
      {loading && <p className="text-gray-500 text-center">Loading...</p>}
      {requests.map((req) => (
        <div key={req._id} className="border p-4 mb-4 rounded-lg shadow-sm">
          <p><strong>Client:</strong> {req.clientId.email}</p>
          <p><strong>Service:</strong> {req.serviceName}</p>
          <p><strong>Role:</strong> {req.roleRequested}</p>
          <p><strong>Details:</strong> {req.requestDetails || 'N/A'}</p>
          <p><strong>Status:</strong> {req.status}</p>
          {req.status === 'pending' && (
            <div className="mt-2 flex gap-2">
              <button
                onClick={() => handleStatus(req._id, 'accepted')}
                className="bg-green-500 text-white p-2 rounded-md hover:bg-green-600"
              >
                Accept
              </button>
              <button
                onClick={() => handleStatus(req._id, 'rejected')}
                className="bg-red-500 text-white p-2 rounded-md hover:bg-red-600"
              >
                Reject
              </button>
            </div>
          )}
        </div>
      ))}
      {!loading && requests.length === 0 && (
        <p className="text-gray-500 text-center">No requests found</p>
      )}
    </div>
  );
};

export default ProviderRequestsDashboard;